import { type createListenerMiddleware, isAnyOf } from '@reduxjs/toolkit';
import { fulfilledWithSettingsMatcher, type SettingsAction, updatePersistor } from 'BreetHelpers';
import {
	type AppDispatch,
	clearCountDownStartTimeArray,
	logUserIn,
	logUserOut,
	type RootState,
	setAuthSettings,
	setCountDownStartTimeArray,
	setFcmToken,
	setIs2faAlert,
	setIsFiatBalanceHidden,
	setShowSecretKey,
	setThemeMode,
} from 'BreetRedux';

export function appListeners(mw: ReturnType<typeof createListenerMiddleware>) {
	const startAppListening = mw.startListening.withTypes<RootState, AppDispatch>();

	startAppListening({
		predicate: isPersistenceAction,
		effect: (_, api) => {
			const state = api.getState();
			updatePersistor({
				countDownStartTimeArray: state.app.countDownStartTimeArray,
				themeMode: state.app.themeMode,
				isUserLoggedIn: state.app.isUserLoggedIn,
				lastVisited: state.app.lastVisited,
				fcmToken: state.app.fcmToken,
				isFiatBalanceHidden: state.app.isFiatBalanceHidden,
				showSecretKey: state.app.showSecretKey,
				is2faAlert: state.app.is2faAlert,
			});
		},
	});

	startAppListening({
		predicate: fulfilledWithSettingsMatcher,
		effect: (action, api) => {
			const { payload } = action as unknown as SettingsAction;
			if (payload.meta?.settings?.fxRates) {
				api.dispatch(setAuthSettings(payload.meta.settings));
			}
		},
	});
}

const isPersistenceAction = isAnyOf(
	clearCountDownStartTimeArray,
	setCountDownStartTimeArray,
	setThemeMode,
	setIsFiatBalanceHidden,
	setFcmToken,
	setShowSecretKey,
	logUserIn,
	logUserOut,
	setIs2faAlert
);
